module.exports = __webpack_public_path__ + "img/DJ.b552952f.png";